import React, { useContext, useRef, useState } from "react";
import "./loginPage.css";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import { Modal } from "../../components/Modals/ModalComponent/Modal";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../../context/LoaderContext";
import { PATCH, POST } from "../../utils/httpUtils";
import { OTPInput } from "../../components/OTPInput/otp-input";
import ChangePasswordModal from "../../components/Modals/ChangePasswordModal/ChangePasswordModal";

import successIcon from "../../assets/images/greenCheck.png";
import { Log } from "../../utils/genericUtils";

function ForgotPasswordPage() {
  const router = useNavigate();

  const [modalActive, setModalActive] = useState(true);

  const error_message = useRef();
  const account_input = useRef();
  const submit_button = useRef();
  const OTP_INPUT = useRef();

  const { show, showloader, hideloader } = useContext(LoaderContext);

  const [username, setUsername] = useState();
  const [token, setToken] = useState(sessionStorage.getItem("password-reset-token") ?? undefined);

  const subtext = "Please provide your username or email so we can send you a verification code.";

  function ShowErrorMessage() {
    if (error_message.current) {
      return <p className="error-message">*{error_message.current}</p>;
    }
  }

  async function ResendCode() {
    showloader();
    let response = await POST("/resend-otp", { username: username, type: "forgot_password" });
    Log("resend response :", response);
    hideloader();
  }

  function GoBack() {
    setToken(undefined);
    sessionStorage.removeItem("password-reset-token");
    router("/login");
  }

  function GetValue() {
    return OTP_INPUT.current.GetValue();
  }

  function OnChar() {
    if (GetValue().length === 7) {
      submit_button.current.disabled = false;
    } else {
      submit_button.current.disabled = true;
    }
  }

  async function SubmitAccountIdentifier() {
    showloader();
    let response = await POST("/forgot-password", { account: account_input.current.value });
    hideloader();
    Log(response);

    if (!response.success) error_message.current = response.error.message;
    else error_message.current = "";
    //set the username
    if (response.username) {
      setUsername(response.username);
    }
  }

  async function SubmitCode() {
    showloader();
    let response = await POST("/verify-forgot-password", { username: username, code: GetValue() });
    hideloader();

    if (!response.success) error_message.current = response.error.message;
    else error_message.current = "";

    //set temporary auth token
    if (response.success && response.isVerified && response.token) {
      sessionStorage.setItem("password-reset-token", response.token);
      setToken(response.token);
    }
  }

  async function SubmitPasswordReset() {
    showloader();
  }

  const subText =
    "A six digit verification code should have been sent to your email address. If you cannot find it please use the resend button below.";

  function RenderModalContent() {
    if (token) {
      return (
        <ChangePasswordModal
          id="forgot-password-modal"
          header={"Reset Password"}
          message={subtext}
          isActive={modalActive}
          animate={false}
          showDivider={true}
          icon={successIcon}
          onCancel={GoBack}
          onCloseModal={() => setModalActive(false)}
          isResetFlow={true}
        >
          <div className="forgot-password-input-box">
            <label htmlFor="">Email or username</label>
            <input type="text" ref={account_input} placeholder="email or username" />
          </div>
          {ShowErrorMessage()}
          <button ref={submit_button} className="standard-button submit-button" onClick={SubmitPasswordReset}>
            Submit
          </button>
          <div className="modal-footnote-box">
            <p>Remember your password?</p>
            <button onClick={GoBack}>Login</button>
          </div>
        </ChangePasswordModal>
      );
    }

    if (username) {
      return (
        <Modal
          id="forgot-password-modal"
          showDivider={true}
          header="Verify Your Account Recovery Code"
          message={subText}
          isActive={true}
          animate={false}
        >
          <OTPInput id={"email-verification-otp"} ref={OTP_INPUT} onKey={OnChar} />
          <div className="email-verification-controls">
            {ShowErrorMessage()}
            <button ref={submit_button} className="standard-button" onClick={SubmitCode}>
              Submit
            </button>
            <div className="modal-footnote-box">
              <p>didn't recieve a code?</p>
              <button onClick={ResendCode}>resend</button>
            </div>
          </div>
        </Modal>
      );
    } else {
      return (
        <Modal id="forgot-password-modal" header={"Forgot Password"} message={subtext} isActive={true} animate={false} showDivider={true}>
          <div className="forgot-password-input-box">
            <label htmlFor="">Email or username</label>
            <input type="text" ref={account_input} placeholder="email or username" />
          </div>
          {ShowErrorMessage()}
          <button ref={submit_button} className="standard-button submit-button" onClick={SubmitAccountIdentifier}>
            Submit
          </button>
          <div className="modal-footnote-box">
            <p>Remember your password?</p>
            <button onClick={GoBack}>Login</button>
          </div>
        </Modal>
      );
    }
  }

  return (
    <>
      <Navbar active="Login"></Navbar>
      <section className="forgot-password-page-bg">{RenderModalContent()}</section>
      <Footer />
    </>
  );
}

export default ForgotPasswordPage;
